import _defineProperty from "/codebuild/output/src908941260/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { naturalCompare } from '../jsutils/naturalCompare.mjs';
import { Kind } from '../language/kinds.mjs';
/**
 * Sort ValueNode.
 *
 * This function returns a sorted copy of the given ValueNode.
 *
 * @internal
 */

export function sortValueNode(valueNode) {
  switch (valueNode.kind) {
    case Kind.OBJECT:
      return _objectSpread(_objectSpread({}, valueNode), {}, {
        fields: sortFields(valueNode.fields)
      });

    case Kind.LIST:
      return _objectSpread(_objectSpread({}, valueNode), {}, {
        values: valueNode.values.map(sortValueNode)
      });

    case Kind.INT:
    case Kind.FLOAT:
    case Kind.STRING:
    case Kind.BOOLEAN:
    case Kind.NULL:
    case Kind.ENUM:
    case Kind.VARIABLE:
      return valueNode;
  }
}

function sortFields(fields) {
  return fields.map(function (fieldNode) {
    return _objectSpread(_objectSpread({}, fieldNode), {}, {
      value: sortValueNode(fieldNode.value)
    });
  }).sort(function (fieldA, fieldB) {
    return naturalCompare(fieldA.name.value, fieldB.name.value);
  });
}